import create from './base'
import {stringify} from 'qs'
import {baseUrl} from '../config'

const http = create()
http.defaults.baseURL = baseUrl + '/api/mechanismindex'


//查询评审机制列表
const queryMechanismIndex = (schoolCode, mechanismId, start, limit) => {
    return http.get('/v1/query?' + stringify({
        schoolCode, mechanismId, start, limit
    }))
}
// 保存评审机制
const saveMechanismIndex = ( dataJson ) => {
    return http.post('/v1/save', stringify(dataJson))
}
// 修改评审机制
const updateMechanismIndex = ( dataJson ) => {
    return http.post('/v1/update', stringify(dataJson))
}
//删除评审机制
const delMechanismIndex = (id) => {
    return http.post('/v1/delete?' + stringify({
        id
    }))
}

// 以下为上海二次需求修改后用到的接口
// 保存评审机制
const saveMechanismIndexTwo = ( data ) => {
    return http.post('/v2/save', data, {
		headers: {
			'Content-Type': 'application/json'
		}
	})
}
// 查询评审维度指标
const queryGetIndex = (data) => {
    return http.get('v1/get_index?' + stringify(data))
}

// 评审指标-删除
const delMechanismIndexTwo = (mechanismId) => {
    return http.post('/v2/delete?' + stringify({
        mechanismId
    }))
}


export default {
    queryMechanismIndex,
    saveMechanismIndex,
    updateMechanismIndex,
    delMechanismIndex,
	saveMechanismIndexTwo,
	queryGetIndex,
	delMechanismIndexTwo
}
